import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils';
import { motion } from 'framer-motion';
import { base44 } from '@/api/base44Client';
import { useQuery } from '@tanstack/react-query';
import MediaDisplay from '@/components/media/MediaDisplay';
import { useLanguage } from '@/i18n/LanguageProvider';

export default function CategorySection() {
  const { t } = useLanguage();
  const { data: categories, isLoading } = useQuery({
    queryKey: ['category-images'],
    queryFn: () => base44.entities.CategoryImage.list('order'),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  if (isLoading || !categories?.length) return null;

  return (
    <section className="bg-white py-14 md:py-32">
      <div className="mx-auto max-w-[1800px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4 md:gap-8">
          {categories.map((category, index) => (
            <motion.div key={category.id} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: index * 0.06 }} viewport={{ once: true }}>
              <Link to={`${createPageUrl('Projects')}?category=${encodeURIComponent(category.filter)}`} aria-label={`${t('Scopri i progetti')} ${t(category.name)}`} className="group relative block aspect-[4/5] overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2d2d2d] focus-visible:ring-offset-2">
                <div className="pointer-events-none h-full w-full transition-transform duration-700 group-hover:scale-105"><MediaDisplay type={category.media_type || 'image'} url={(category.media_type || 'image') === 'video' ? category.video_url : category.image} meta={category.image_meta || { title: category.name }} autoplay={(category.media_type || 'image') === 'video'} className="h-full w-full object-cover" /></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h2 className="text-white text-xl md:text-2xl font-serif font-light tracking-wide">{t(category.name)}</h2>
                  <div className="mt-3 w-8 h-px bg-white/60 transition-all duration-500 group-hover:w-16 group-hover:bg-white" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}